import { ReactNode } from "react";

interface IProps {
    isOpen: boolean,
    onClick: () => void,
    children: ReactNode,
    className?: string
}

const ButtonPopup = ({ isOpen, children, className, onClick }: IProps) => {
    return (
        <button className={`text-neutral-200 rounded-full px-1.5 py-1.5 transition ${isOpen
            ? "bg-[#008DD2] text-white"
            : "bg-neutral-600"
            } ${className}`}
            onClick={onClick}>
            {children}
        </button>
    );
};

export default ButtonPopup;